// extracted by mini-css-extract-plugin
module.exports = {"commentHeader":"_3o-oE","search":"_2K8oA","commentTime":"_3sXE_","withMoreButton":"_35F4l","moreButton":"_2tKWP"};